import React from "react";
import { map } from "lodash";
import cn from "classnames";

const YearsSelectorInner = ({
  years, onChange, currentYear, className
}) => {
  const handleClick = (year) => {
    if (year === currentYear) {
      return;
    }
    onChange(year);
  };

  return (
    <h4 className={ cn('years_title', className) }>
      {
        map(years, (y) => (
          <span
            key={ `Year${y}` }
            className={ cn("year", { "-active": y === currentYear }) }
            onClick={ () => {handleClick(y);} }
          >
            {y}
          </span>
        ))
      }
    </h4>
  );
};

const YearsSelector = (props) => {
  const { withSection, years } = props;
  return (
    <>
      {
        years && years.length > 1 &&
        <>
          {
            withSection &&
            <div className="section_top">
              <YearsSelectorInner { ...props } />
            </div>
          }
          { !withSection && <YearsSelectorInner { ...props } /> }
        </>
      }
    </>
  );
};

export default YearsSelector;
